var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightChevronIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17548 4.30048C9.49278 3.98317 10.0072 3.98317 10.3245 4.30048L18.4495 12.4255C18.7668 12.7428 18.7668 13.2572 18.4495 13.5745L10.3245 21.6995C10.0072 22.0168 9.49278 22.0168 9.17548 21.6995C8.85817 21.3822 8.85817 20.8678 9.17548 20.5505L16.726 13L9.17548 5.44952C8.85817 5.13222 8.85817 4.61778 9.17548 4.30048Z",
    fill: "#050505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightChevronIcon);
export default __webpack_public_path__ + "static/media/rightChevronIcon.4812d794979f78b2eda9d29e37e42fed.svg";
export { ForwardRef as ReactComponent };